/**
 * Checks if the provided value matches the standard MongoDB ObjectId format.
 * An ObjectId is a 24-character hexadecimal string.
 *
 * @param {any} value - The value to verify.
 * @returns {boolean} - Returns true if 'value' is a string consisting of exactly
 * 24 hexadecimal characters; otherwise, returns false.
 */
const isObjectId = (string) => {
	let validMongoID = new RegExp('^[0-9a-fA-F]{24}$');

	return validMongoID.test(string);
}

export default isObjectId;
